import React, { useEffect, useState } from 'react';

import * as constants from '../utils/constants';
import { checkIfHotjarEnable, timeBetweenDates } from '../utils/helpers';
import history from '../utils/history';
import RimacTopBar from '../components/common/RimacTopBar/RimacTopBar';
import Button from '../components/common/button/Button';
import MenThankYou from '../assets/ilu_thanks_left.svg';
import docExample from '../assets/documents.v2/carta_de_respuesta_BBVA.png';

const defaultContent = (onClickBBVA) => (
  <div className="thanksPage__old-right pageContainer__right">
    <div className="titleCont">
      <h3 className="u-mb-16">
        ¡Listo! Hemos recibido tu solicitud con éxito.
      </h3>
      <p className="u-mb-40">
        En los próximos minutos, te estaremos enviando un correo electrónico
        indicándote el <b>número de siniestro generado.</b>
      </p>
    </div>

    <section className="infoSection u-mb-40">
      <h4 className="infoSection__title">Ten en cuenta lo siguiente:</h4>
      <ul className="infoSection__list">
        <li>
          El plazo de evaluación de un siniestro es de
          <b> 30 días calendario</b>, siguientes a la presentación de toda la
          información completa señalada en tu contrato de seguro. Sin embargo,
          haremos todo lo posible para responderte antes de ese plazo.
        </li>
        <li>
          Podríamos solicitarte documentación y/o información adicional.
          <b>
            {' '}
            Mantente atento a tu correo electrónico. No olvides revisar el spam.
          </b>
        </li>
        <li>
          Para consultas sobre el estado de tu solicitud, llámanos al
          <b> (01) 595 9000 opción 3.</b>
        </li>
      </ul>
    </section>

    <Button primary className="btnReturn">
      <a href={constants.LINK_PRODUCTOS_BBVA} onClick={onClickBBVA}>
        Volver a BBVA
      </a>
    </Button>
  </div>
);

const alterContent = (onClickLink) => (
  <div className="thanksPage__old-right pageContainer__right">
    <div className="titleCont">
      <h3 className="u-mb-16">Compras vía internet no reconocidas</h3>
    </div>

    <section className="infoSection u-mb-40">
      <p className="u-mb-16">Repórtalo a través de los siguientes canales:</p>
      <ul className="infoSection__list">
        <li>
          Banca por internet.{' '}
          <a
            className="purple"
            onClick={() => onClickLink('bank')}
            href={constants.LINK_BBVA_BANCA}
            target="_blank"
            rel="noopener noreferrer"
          >
            Ver aquí
          </a>
        </li>
        <li>
          App BBVA.{' '}
          <a
            className="purple"
            onClick={() => onClickLink('mobile')}
            href={constants.LINK_BBVA_BANCA_MOBILE}
            target="_blank"
            rel="noopener noreferrer"
          >
            Ver aquí
          </a>
        </li>
        <li>
          Email:{' '}
          <a className="purple" href="mailto: terespondemos@bbva.com">
            terespondemos@bbva.com
          </a>
        </li>
        <li>
          Contact Center: Te puedes comunicar directamente al{' '}
          <b>(01) 595 0000.</b>
        </li>
      </ul>

      <div className="infoSection__text">
        Si ya cuentas con la <b>carta de respuesta</b> del BBVA (ver ejemplo{' '}
        <a
          className="purple"
          href={docExample}
          target="_blank"
          rel="noopener noreferrer"
        >
          aquí
        </a>
        ). Puedes enviar un correo explicando tu caso a{' '}
        <b>siniestrosprotecciondetarjeta@bbva.com</b> con el asunto
        <b>"Compras no reconocidas por internet"</b>{' '}
        o comunícate al <b>(01)595-9000 opción 3.</b>
      </div>
    </section>

    <div className="btnContainer">
      <Button
        secondary
        className="btnReturn__alter"
        onClick={() => {
          history.goBack();
          onClickLink('return');
        }}
      >
        Regresar
      </Button>
      <Button primary className="btnReturn u-ml-12">
        <a
          href={constants.LINK_PRODUCTOS_BBVA}
          onClick={() => onClickLink('bbva')}
        >
          Volver a BBVA
        </a>
      </Button>
    </div>
  </div>
);

const ThankYouPage = ({ location }) => {
  const [viewStartTime, setViewStartTime] = useState(new Date());
  const params = new URLSearchParams(location.search).get('alter');

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

    if (params && checkIfHotjarEnable()) {
      window.digitalData.push({
        virtual: {
          name: 'web:tramites-siniestros:proteccion-tarjeta:gracias-alternativo',
        },
        event: 'trackVirtual',
      });
    }

    return () => {
      const endTime = new Date();
      const userTotalTime = timeBetweenDates(viewStartTime, endTime);

      if (checkIfHotjarEnable()) {
        window.digitalData.push({
          task: {
            name: 'Tiempo registrado - Gracias',
            time: userTotalTime,
          },
          event: 'trackTimeToComplete',
        });
      }
    };
  }, []);

  const onClickLinkAlter = (link) => {
    if (!checkIfHotjarEnable()) return;

    if (link === 'bbva') {
      window.digitalData.push({
        action: {
          group: 'Tramites Siniestros – Protección Tarjeta BBVA',
          category: 'Thank you Page',
          name: 'Botón',
          label: 'Volver a BBVA',
        },
        event: 'trackAction',
      });
    } else if (link === 'bank') {
      window.digitalData.push({
        action: {
          group: 'Tramites Siniestros – Protección Tarjeta BBVA',
          category: 'Compras no reconocidas',
          name: 'Click',
          label: 'Banca por internet',
        },
        event: 'trackAction',
      });
    } else if (link === 'mobile') {
      window.digitalData.push({
        action: {
          group: 'Tramites Siniestros – Protección Tarjeta BBVA',
          category: 'Compras no reconocidas',
          name: 'Click',
          label: 'App BBVA',
        },
        event: 'trackAction',
      });
    } else if (link === 'return') {
      window.digitalData.push({
        action: {
          group: 'Tramites Siniestros – Protección Tarjeta BBVA',
          category: 'Compras no reconocidas',
          name: 'Click',
          label: 'Regresar',
        },
        event: 'trackAction',
      });
    }
  };

  const onClickLinkDefault = () => {
    if (checkIfHotjarEnable()) {
      window.digitalData.push({
        action: {
          group: 'Tramites Siniestros – Protección Tarjeta BBVA',
          category: 'Thank you Page',
          name: 'Botón',
          label: 'Volver a BBVA',
        },
        event: 'trackAction',
      });
    }
  };

  return (
    <>
      <RimacTopBar />
      <div data-testid="thank-you-page" className="thanksPage pageContainer">
        <div className="thanksPage__old-left pageContainer__left">
          <div className="titleCont">
            <img className="mascota" src={MenThankYou} alt="rimac mascota" />
          </div>
        </div>

        {params
          ? alterContent(onClickLinkAlter)
          : defaultContent(onClickLinkDefault)}

        <div className="spacingLeft"></div>
      </div>
    </>
  );
};

export default ThankYouPage;
